import axios from "axios";
const protocol = window.location.protocol;

export default axios.create({
   baseURL: 'https://superplayerauction.com/dataapi/',
  //  baseURL: "http://localhost/auction/dataapi/", 
   /*headers: {
     "Content-Type": "multipart/form-data",
     "Accept": "application/json",
     "type": "formData"
   },*/
});